// extracted by mini-css-extract-plugin
export default {"buttonLikeCircle":"style_buttonLikeCircle__F4utL","large":"style_large__oArrA"};